export default __webpack_public_path__ + "static/Centric_Events_Rentals-f323907f626b956f8381d448e3bc63e6.jpg";